import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import $ from 'jquery'
import Select from 'react-select';
import { getEmpresaSelecionada } from '../../util/empresaSelecionada'
import alterarEmpresaSelecionada from '../../actions/empresa/alterarEmpresaSelecionada'
import buscarEmpresas from '../../actions/empresa/buscarEmpresas';

export class CampoSelecionarEmpresa extends Component {
  constructor (props) {
    super(props);
    this.handleEmpresaChange = this.handleEmpresaChange.bind(this);

    this.refAutoComplete = React.createRef()
  }

  determinaEmpresaSelecionada () {
    const empresaSelecionada = getEmpresaSelecionada();

    return empresaSelecionada || (this.props.empresas ? this.props.empresas[0] : null)
  }

  componentDidMount () {
    this.props.buscarEmpresas()
    if (this.props.authentication.isAuthenticated) {
      this.props.alterarEmpresaSelecionada(this.determinaEmpresaSelecionada());
      // this.refNav.current.addEventListener("shown.bs.dropdown", this.handleClick.bind(this))
      $('#dropdownGrupos')
        .on('shown.bs.dropdown', this.handleClick.bind(this))
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.authentication !== this.props.authentication && this.props.authentication.isAuthenticated) {
      this.props.alterarEmpresaSelecionada(this.determinaEmpresaSelecionada());
      $('#dropdownGrupos')
        .on('shown.bs.dropdown', this.handleClick.bind(this))
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleEmpresaChange (empresa) {
    const emp = this.props.empresas.filter(f=>f.id === empresa.value)[0]
    this.props.alterarEmpresaSelecionada(emp)
  }

  possuiGrupos () {
    return this.props.empresas && this.props.empresas.length
  }

  isMostraAutocomplete () {
    return (this.props.empresas.length > 10)
  }

  handleClick (event) {
    if (this.refAutoComplete.current) {
      this.refAutoComplete.current.getWrappedInstance()
        .focus(event)
    }
  }

  render () {
    if (!this.possuiGrupos() || !this.props.empresaSelecionada) {
      return <div>Carregando...</div>
    }

    return (
      <React.Fragment>
      <label>Empresa</label>
      <Select
        maxMenuHeight={400}
        menuPlacement="auto"
        noOptionsMessage={() => ('Nenhuma opção encontrada')}
        placeholder='Selecione uma empresa'
        options={this.props.empresas.map(elemento => ({
          label: elemento.nomeFantasia,
          value: elemento.id
        }))}
        value={this.props.empresaSelecionada ? ({
          label: this.props.empresaSelecionada.nomeFantasia,
          value: this.props.empresaSelecionada.id
        }) : ''}
        onChange={value => this.handleEmpresaChange(value)}
      />
      </React.Fragment>
    )
  }
}

export function mapStateToProps (state) {
  return {
    empresas: state.empresas,
    empresaSelecionada: state.empresaSelecionada,
    authentication: state.authentication,
  }
}

export default withRouter(connect(mapStateToProps, { alterarEmpresaSelecionada, buscarEmpresas })(CampoSelecionarEmpresa))
